import { AppData } from '../AppContext';
import { getNullableVariation, getVariation } from './artikel';
import { isDisabled, isHidden } from './restrictions';

export const getNullableSelectedVariationWert = (
  artikel: Artikel,
  variationWerte: ArtikelVariationWerte,
  kEigenschaft: number
): ArtikelVariationWert | null => {
  const variation = getNullableVariation(artikel, kEigenschaft);
  const werte = variation?.Werte;
  const wert = werte?.find((w) => w.kEigenschaftWert === variationWerte[kEigenschaft]);
  if (!wert) {
    return null;
  }
  return wert;
};

export const getSelectedVariationWert = (
  artikel: Artikel,
  variationWerte: ArtikelVariationWerte,
  kEigenschaft: number
): ArtikelVariationWert => {
  const wert = getNullableSelectedVariationWert(artikel, variationWerte, kEigenschaft);
  if (!wert) {
    throw new Error(`Ausgewählter VariationWert für Variation mit kEigenschaft:${kEigenschaft} nicht im Artikel gefunden`);
  }
  return wert;
};

export const getFirstUnrestrictedVariationWert = (
  artikel: Artikel,
  konfig: ArtikelKonfiguration,
  variationWerte: ArtikelVariationWerte,
  kEigenschaft: number
): ArtikelVariationWert => {
  const variation = getVariation(artikel, kEigenschaft);
  const werte = variation.Werte;
  const config = konfig.variations[kEigenschaft];
  if (config) {
    const unrestricted = artikel.variationen
      .filter((v) => v.kEigenschaft === kEigenschaft)
      .flatMap((v) => v.Werte)
      .filter((w) => !isDisabled(artikel, konfig, variationWerte, w.kEigenschaftWert) && !isHidden(artikel, konfig, variationWerte, w.kEigenschaftWert));
    return unrestricted[0];
  }
  return werte[0];
};

export const sumAufpreise = (appData: AppData): number => Object.keys(appData.dynamic.selectedVariationWerte)
  .reduce((value, kEigenschaftAsString) => {
    const kEigenschaft = Number(kEigenschaftAsString);
    const variation = getVariation(appData.static.artikel, kEigenschaft);
    let aufpreis = 0;
    if (variation.kEigenschaft !== appData.static.kEigenschaftBreite
      && variation.kEigenschaft !== appData.static.kEigenschaftHoehe
      && variation.kEigenschaft !== appData.static.kEigenschaftLaenge
      && variation.kEigenschaft !== appData.static.kEigenschaftVersand
      && variation.kEigenschaft !== appData.static.kEigenschaftWandschienenhoehe) {
      const wert = getSelectedVariationWert(appData.static.artikel, appData.dynamic.selectedVariationWerte, kEigenschaft);
      aufpreis = wert.fAufpreis ? wert.fAufpreis[0] : 0;
    }
    return value + aufpreis;
  }, 0);

export const getBreite = (appData: AppData): number => {
  const kEigenschaft = appData.static.kEigenschaftBreite;
  return appData.dynamic.selectedVariationWerte[kEigenschaft];
};

export const getHoehe = (appData: AppData): number => {
  const kEigenschaft = appData.static.kEigenschaftHoehe;
  return appData.dynamic.selectedVariationWerte[kEigenschaft];
};

export const getLaenge = (appData: AppData): number => {
  const kEigenschaft = appData.static.kEigenschaftLaenge;
  return appData.dynamic.selectedVariationWerte[kEigenschaft];
};

export const getTiefe = (appData: AppData): number => {
  const kEigenschaft = appData.static.kEigenschaftTiefe;
  return appData.dynamic.selectedVariationWerte[kEigenschaft];
};

export const getWandschienenhoehe = (appData: AppData): number => {
  const kEigenschaft = appData.static.kEigenschaftWandschienenhoehe;
  return appData.dynamic.selectedVariationWerte[kEigenschaft];
};
